(ns dashboard.entity.analysis.policy-process-pairs
  (:require ["react" :as react]
            [clojure.set :as set]
            [dashboard.entity.analysis.search :as analysis.search]
            [dashboard.entity.analysis.tree :as analysis.tree]
            [dashboard.services.http-config :as http-config]
            [dashboard.ui :as ui]
            [re-frame.core :as rf]))

(rf/reg-event-db
 ::set-policy-process-pairs-success
 (fn [db [_ ppp]]
   (-> db
       (assoc-in [:policy-process-pairs :data]
                 (mapv
                  (fn [{:keys [construct-id construct process]}]
                    {:policy-construct-id construct-id
                     :policy-construct construct
                     :process-construct-id (:construct-id process)
                     :process-construct (:construct process)})
                  (-> ppp :pairs)))
       (assoc :requested-policy-process-pairs false)
       (update-in [:policy-process-pairs :query-count] (fnil inc 1)))))

(rf/reg-event-fx
 ::set-policy-process-pairs-failure
 (fn [{:keys [db]} [_ message error]]
   (js/console.log message)
   (js/console.log error)
   {:fx [[:dispatch [::ui/set-error (str message ": " (select-keys error [:failure :status-text :status :original-text]))]]]
    :db (assoc db :requested-policy-process-pairs false)}))

(rf/reg-sub
 ::policy-process-pairs
 (fn [db [_]]
   (get-in db [:policy-process-pairs :data])))

(defn get-policy-process-pairs*
  []
  (rf/subscribe [::policy-process-pairs]))

(rf/reg-event-fx
  ::fetch-policy-process-pairs
  (fn [{:keys [db]} [_ query force-requery]]
    (if (and (or force-requery (-> db :policy-process-pairs :data nil?))
             (not (:requested-policy-process-pairs db)))
      (let [request {:method          :post
                     :uri             "/api/recommendations/policy-process-pairs/"
                     :timeout         http-config/timeout
                     :format          http-config/transit-request-format
                     :response-format http-config/transit-response-format
                     :on-success      [::set-policy-process-pairs-success]
                     :on-failure      [::set-policy-process-pairs-failure
                                       "Failed to retrieve Policy/Process pairs"]}]
        (js/console.log "Sending request:" (clj->js request))
        {:db (assoc db :requested-policy-process-pairs true)
         :http-xhrio request})
      {:db db})))

(defn fetch-policy-process-pairs
  [& [force-requery]]
  (rf/dispatch [::fetch-policy-process-pairs "" force-requery]))

(defn get-analysis-pair
  [base-analysis process-policy-pairs]
  (let [base-category (->> base-analysis
                           :structured-analysis
                           :categories
                           first
                           :name)
        search-key (if (= base-category "Policy")
                     :policy-construct-id
                     :process-construct-id)
        result-key (if (= base-category "Policy")
                     :process-construct-id
                     :policy-construct-id)
        construct-key (if (= base-category "Policy")
                        :process-construct
                        :policy-construct)
        sibling (->> process-policy-pairs
                     (filterv (fn [pair] (= (get pair search-key)
                                            (:construct-id base-analysis))))
                     first)]
    (-> sibling
        (select-keys [result-key construct-key])
        (assoc :category (if (= base-category "Policy")
                           "Operations (process)"
                           "Policy"))
        (set/rename-keys {:process-construct :construct
                          :process-construct-id :construct-id
                          :policy-construct :construct
                          :policy-construct-id :construct-id}))))

(defn PolicyProcessPairs
  [base-analysis policy-process-pairs on-link-analysis]
  (let [all-analyses @(analysis.search/all-analysis-structures)]
    (react/useEffect
     (fn [] (when-not policy-process-pairs (fetch-policy-process-pairs)))
     (array policy-process-pairs))

    [:div.policy-process-pairs
     {:key (keyword :policy-pair (:construct-id base-analysis))
      :style {:min-width "800px"}}
     [:div.level
      [:div.is-flex-grow-1
       [:h3.title.is-6
        [:i.icon.fas.fa-star-half-stroke.mr-2]
        "Policy / Process Pairing"]
       (when (and all-analyses (seq @(get-policy-process-pairs*)))
        (let [sibling (get-analysis-pair base-analysis policy-process-pairs)]
          [:div.is-flex.is-flex-grow-1
           [:f> analysis.tree/AnalysisTree
            {:hide-category true
             :hide-category-selection true
             :on-click-construct #(on-link-analysis
                                   (-> all-analyses
                                       (->> (filterv (comp (partial = (:construct-id sibling))
                                                           :construct-id)))
                                       first
                                       :applied-analyses
                                       first
                                       (select-keys [:construct-id :version-id])
                                       vector
                                       set
                                       ))
             :on-select identity
             :preselected-version-ids #{}
             :selected-version-ids #{(:construct-id sibling)}
             :display-construct-ids (analysis.tree/get-analysis-tree-displayed-construct-ids
                                     (vec all-analyses)
                                     #{(:construct-id sibling)})
             :category (or (:category sibling) "Operations (process)")
             :loading false
             :analyses all-analyses
             :search-result-construct-ids #{(:construct-id sibling)}
             :active-query true ;(not (str/blank? query))
             :row-component analysis.tree/ListItemAnalysisRow}]]))]]]))